import { render, staticRenderFns } from "./ModalResultadoEstudante.vue?vue&type=template&id=530f2052"
import script from "./ModalResultadoEstudante.vue?vue&type=script&lang=js"
export * from "./ModalResultadoEstudante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports